<template>
  <div>
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <v-card class="login-card">
          <v-col
            cols="12"
            style="background-color: #f96654"
            class="d-flex align-center justify-center"
          >
            <img
              :src="require('../../assets/Dynamic_Pricing.svg')"
              class="logo-image"
            />
          </v-col>
          <v-card-text class="pb-0">
            <v-form ref="login_form" id="login_form" lazy-validation>
              <v-row>
                <v-col cols="12" class="login-content">
                  <div class="font-weight-bold lg-text mb-8 mt-4 text-center">Sign In</div>
                  <v-row>
                    <v-col cols="12" class="pt-0 pb-0 mb-4">
                      <v-text-field
                        placeholder="Username or Email"
                        prepend-inner-icon="mdi-account"
                        ref="username"
                        v-model="username"
                        :rules="[rules.required]"
                        label="Username or Email"
                        :error="isWrong"
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-0 mb-4">
                      <v-text-field
                        placeholder="Password"
                        prepend-inner-icon="mdi-form-textbox-password"
                        ref="password"
                        v-model="password"
                        :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min]"
                        :type="show_password ? 'text' : 'password'"
                        label="Password"
                        hint="At least 8 characters"
                        @click:append="show_password = !show_password"
                        :error="isWrong"
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-0 mb-4">
                      <div class="text-center forgot-password">
                        Forgot your password?
                        <a @click="gotoEmailInsert()" class="link-text">Reset your password</a>
                      </div>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-4">
                      <submitButton
                        id="login_btn"
                        :submitFunction="login"
                        :submit_loading="loading"
                        class="w-100"
                        color="error"
                        text="Sign In"
                      />
                    </v-col>
                    <!-- <v-col cols="12" class="pt-0 pb-2" v-if="false">
                      <v-divider class="mb-4">
                        <span class="text-caption text-grey">OR</span>
                      </v-divider>
                      <v-btn
                        @click="handleGoogleSignInClick"
                        :loading="googleLoading"
                        :disabled="googleLoading"
                        color="white"
                        elevation="1"
                        large
                        block
                        class="google-signin-btn"
                      >
                        <template v-slot:loader>
                          <v-progress-circular
                            indeterminate
                            size="20"
                            width="2"
                            color="primary"
                          ></v-progress-circular>
                          <span class="ml-2">Signing in with Google...</span>
                        </template>
                        <span class="mr-2">
                          <svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                            <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <g id="Color-" transform="translate(-401.000000, -860.000000)">
                                <g id="Google" transform="translate(401.000000, 860.000000)">
                                  <path d="M9.82727273,24 C9.82727273,22.4757333 10.0804318,21.0144 10.5322727,19.6437333 L2.62345455,13.6042667 C1.08206818,16.7338667 0.213636364,20.2602667 0.213636364,24 C0.213636364,27.7365333 1.081,31.2608 2.62025,34.3882667 L10.5247955,28.3370667 C10.0772273,26.9728 9.82727273,25.5168 9.82727273,24" id="Fill-1" fill="#FBBC05"></path>
                                  <path d="M23.7136364,10.1333333 C27.025,10.1333333 30.0159091,11.3066667 32.3659091,13.2266667 L39.2022727,6.4 C35.0363636,2.77333333 29.6954545,0.533333333 23.7136364,0.533333333 C14.4268636,0.533333333 6.44540909,5.84426667 2.62345455,13.6042667 L10.5322727,19.6437333 C12.3545909,14.112 17.5491591,10.1333333 23.7136364,10.1333333" id="Fill-2" fill="#EB4335"></path>
                                  <path d="M23.7136364,37.8666667 C17.5491591,37.8666667 12.3545909,33.888 10.5322727,28.3562667 L2.62345455,34.3946667 C6.44540909,42.1557333 14.4268636,47.4666667 23.7136364,47.4666667 C29.4455,47.4666667 34.9177955,45.4314667 39.0249545,41.6181333 L31.5177727,35.8144 C29.3995682,37.1488 26.7323182,37.8666667 23.7136364,37.8666667" id="Fill-3" fill="#34A853"></path>
                                  <path d="M46.1454545,24 C46.1454545,22.6133333 45.9318182,21.12 45.6113636,19.7333333 L23.7136364,19.7333333 L23.7136364,28.8 L36.3181818,28.8 C35.6879545,31.8912 33.9724545,34.2677333 31.5177727,35.8144 L39.0249545,41.6181333 C43.3393409,37.6138667 46.1454545,31.6490667 46.1454545,24" id="Fill-4" fill="#4285F4"></path>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </span>
                        Continue with Google
                      </v-btn>
                      <div id="g_id_signin" style="display: none;"></div>
                    </v-col> -->
                    <v-col cols="12" class="pt-0 pb-4 mt-4">
                      <div class="text-center signup-text">
                        No account yet?
                        <a @click="gotoSubscription()" class="link-text">Sign up now</a>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" class="mb-0 d-flex justify-center">
        <v-alert
          class="mobile-alert"
          :value="isWrong"
          color="error"
          dark
          border="right"
          icon="mdi-alert"
          transition="scale-transition"
        >
          E-mail or password not valid
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Login",
  props: {
    msg: String,
  },
  data: () => {
    return {
      password: "",
      username: "",
      alert: false,
      isWrong: false,
      show_password: false,
      loading: false,
      googleLoading: false,
      rules: {
        required: (value) => !!value || "This field is required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
    };
  },
  methods: {
     login() {
      if (this.$refs.login_form.validate()) {
        const { username, password } = this;
        this.loading = true;
        this.$store
          .dispatch("AUTH_REQUEST", { username, password })
          .then((res) => {
            this.loading = false;
            if (!res) {
              this.isWrong = true;
            } else {
              this.isWrong = false;
              this.$router.push("/Pricing");
            }
          });
      }
    },
    enterClicked() {
      document.addEventListener("keyup", function(event) {
        // Number 13 is the "Enter" key on the keyboard
        if (event.keyCode === 13) {
          // Cancel the default action, if needed
          event.preventDefault();
          document.getElementById("login_btn").click();
        }
      });
    },
    gotoEmailInsert() {
      this.$router.push("/EmailInsert");
    },
    gotoSubscription() {
      this.$router.push("/subscription");
    },
    //handleGoogleSignInClick() {
    //  if (window.google && window.google.accounts && window.google.accounts.id) {
    //    this.googleLoading = true;
    //    // Trigger Google One Tap sign-in programmatically
    //    window.google.accounts.id.prompt((notification) => {
    //      if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
    //        // Fallback to popup if One Tap is not available
    //        this.showGooglePopup();
    //      }
    //    });
    //  } else {
    //    console.error('Google Sign-In not initialized');
    //    this.googleLoading = false;
    //  }
    //},
    //showGooglePopup() {
    //  // Fallback method to show Google sign-in popup
    //  if (window.google && window.google.accounts && window.google.accounts.oauth2) {
    //    const client = window.google.accounts.oauth2.initTokenClient({
    //      client_id: '158271278219-103145mbnb2ds0vrlirrk945r3op5jh4.apps.googleusercontent.com',
    //      scope: 'email profile',
    //      callback: (response) => {
    //        // Handle OAuth2 response - you might need to get user info separately
    //        this.handleOAuth2Response(response);
    //      },
    //    });
    //    client.requestAccessToken();
    //  }
    //},
    handleOAuth2Response(response) {
      // This is a fallback handler for OAuth2 flow
      // You might need to make additional API calls to get user info
      console.log('OAuth2 Response:', response);
      this.googleLoading = false;
    },
    initializeGoogleSignIn() {
      if (window.google && window.google.accounts && window.google.accounts.id) {
        try {
          window.google.accounts.id.initialize({
            client_id: '158271278219-103145mbnb2ds0vrlirrk945r3op5jh4.apps.googleusercontent.com',
            callback: this.handleGoogleSignIn,
            auto_select: false,
            cancel_on_tap_outside: true
          });
          
          const buttonElement = document.getElementById('g_id_signin');
          if (buttonElement) {
            window.google.accounts.id.renderButton(
              buttonElement,
              { 
                theme: 'outline', 
                size: 'large', 
                width: '100%',
                text: 'signin_with',
                shape: 'rectangular'
              }
            );
          }
        } catch (error) {
          console.error('Error initializing Google Sign-In:', error);
        }
      } else {
        console.warn('Google Sign-In API not yet loaded');
      }
    },
    handleGoogleSignIn(response) {
      // Don't set googleLoading = true here since it might already be set by the button click
      console.log('Google Sign-In Response:', response);
      
      try {
        // Decode the JWT token to get user information
        const payload = JSON.parse(atob(response.credential.split('.')[1]));
        console.log('User Info:', payload);
        
        // Here you can integrate with your existing authentication system
        // You might want to send the token to your backend for verification
        const googleUserData = {
          email: payload.email,
          name: payload.name,
          picture: payload.picture,
          google_id: payload.sub,
          token: response.credential
        };
        
        // You can dispatch to your store or make an API call here
        this.handleGoogleAuth(googleUserData);
        
      } catch (error) {
        console.error('Error processing Google Sign-In:', error);
        this.googleLoading = false;
        // Show error message to user
        this.isWrong = true;
      }
    },
    async handleGoogleAuth(userData) {
      try {
        this.googleLoading = true;
        
        // Create Google auth data for the dedicated Google endpoint
        const googleAuthData = {
          username: userData.email, // Use email as username for Google auth
          google_token: userData.token,
          google_id: userData.google_id,
          google_name: userData.name,
          google_picture: userData.picture
        };
        
        console.log('Processing Google authentication for:', userData.email);
        console.log('Google auth data:', googleAuthData);

        //check first if user already exist if not let's prompt a plan selection


        
        // Use the dedicated GOOGLE_AUTH_REQUEST action
        const res = await this.$store.dispatch("GOOGLE_AUTH_REQUEST", googleAuthData);

        
        this.googleLoading = false;
        
        if (!res) {
          this.isWrong = true;
          console.error('Google authentication failed!');
        } else {
          this.isWrong = false;
          console.log('Google authentication successful');
          this.$router.push("/");
        }
        
      } catch (error) {
        console.error('Google authentication failed:', error);
        this.googleLoading = false;
        this.isWrong = true;
      }
    },
    waitForGoogleScript() {
      if (window.google && window.google.accounts && window.google.accounts.id) {
        this.initializeGoogleSignIn();
      } else {
        // Check multiple times with increasing intervals
        let attempts = 0;
        const maxAttempts = 50; // 5 seconds total
        
        const checkGoogleLoaded = () => {
          attempts++;
          
          if (window.google && window.google.accounts && window.google.accounts.id) {
            this.initializeGoogleSignIn();
          } else if (attempts < maxAttempts) {
            setTimeout(checkGoogleLoaded, 100);
          } else {
            console.error('Google Sign-In script failed to load after 5 seconds');
          }
        };
        
        setTimeout(checkGoogleLoaded, 100);
      }
    }
  },
  async mounted() {
    if (!this.$store.getters.isAuthenticated) {
      try {
        this.$socket.client.emit(
          "DisconnectListening",
          {
            user_id: localStorage.getItem("user_id"),
          },
          (resp) => {
            this.$store.dispatch("socketDestroyed");
          }
        );
      } catch (ex) {
        console.log(ex);
      }
      await this.$store.dispatch("AUTH_LOGOUT");
      this.$router.push("/login");
    }
    if (this.$route.query.from_insert_email || false) this.alert = true;
    this.enterClicked();
    
    // Initialize Google Sign-In with better loading detection
    this.$nextTick(() => {
      this.waitForGoogleScript();
    });
  }
};
</script>

<style scoped>
a {
  color: #2563eb !important;
}

/* Mobile-friendly card */
.login-card {
  width: 100%;
  max-width: 500px;
  margin: 0 16px;
}

/* Desktop card width */
@media (min-width: 960px) {
  .login-card {
    width: 25%;
    margin: 0;
  }
}

/* Mobile-friendly logo */
.logo-image {
  max-width: 220px;
  width: 100%;
  height: auto;
}

/* Responsive padding for login content */
.login-content {
  padding: 16px;
  padding-bottom: 24px;
}

@media (min-width: 600px) {
  .login-content {
    padding: 32px;
    padding-top: 16px;
    padding-bottom: 32px;
  }
}

/* Mobile-friendly alert */
.mobile-alert {
  width: 100%;
  max-width: 500px;
  margin: 0 16px;
}

@media (min-width: 960px) {
  .mobile-alert {
    width: 30%;
    margin: 0;
  }
}

/* Improve touch targets on mobile */
@media (max-width: 599px) {
  .v-text-field {
    margin-bottom: 8px;
  }
  
  .v-btn {
    min-height: 48px;
  }
}

/* Bottom text styling improvements */
.forgot-password {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
  color: #6b7280;
}

.signup-text {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 0;
  color: #6b7280;
}

.link-text {
  color: #2563eb !important;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.link-text:hover {
  color: #1d4ed8 !important;
  text-decoration: underline;
}

/* Better spacing on mobile */
@media (max-width: 599px) {
  .forgot-password,
  .signup-text {
    font-size: 13px;
    padding: 0 8px;
  }
  
  .link-text {
    display: block;
    margin-top: 4px;
  }
}

/* Better spacing on larger screens */
@media (min-width: 600px) {
  .forgot-password {
    margin-bottom: 16px;
  }
  
  .link-text {
    margin-left: 4px;
  }
}

/* Google Sign-In button styling */
.google-signin-btn {
  border: 1px solid #dadce0 !important;
  color: #3c4043 !important;
  font-weight: 500 !important;
  letter-spacing: 0.25px !important;
  text-transform: none !important;
}

.google-signin-btn:hover {
  box-shadow: 0 1px 2px 0 rgba(60,64,67,.30), 0 1px 3px 1px rgba(60,64,67,.15) !important;
}

.google-signin-btn:focus {
  box-shadow: 0 1px 2px 0 rgba(60,64,67,.30), 0 1px 3px 1px rgba(60,64,67,.15) !important;
}

.google-signin-btn .v-btn__content {
  font-size: 14px !important;
}

#g_id_signin {
  display: none;
}

/* Divider styling */
.v-divider {
  position: relative;
}

.v-divider span {
  background: white;
  padding: 0 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>